export default __webpack_public_path__ + "media/verify_user_account_email/title_locale_sv-87dab9db.png";